import { RefreshCw } from "lucide-react";
import { adminPanelSections } from "../data/admin-panel.sections";
import type { AdminSection } from "../types/admin-panel";

type Props = {
  active: AdminSection;
  onReload: () => void | Promise<void>;
  loading: boolean;
};

export function AdminPanelHeader({ active, onReload, loading }: Props) {
  const section =
    adminPanelSections.find((s) => s.id === active) ?? adminPanelSections[0];

  const Icon = section.icon;

  return (
    <div className="scroll-reveal-right relative overflow-hidden border-b border-[#dfe8e4] bg-[linear-gradient(135deg,#ffffff_0%,#f3fbf7_100%)] px-6 py-5">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -right-20 top-[-90px] h-[240px] w-[240px] rounded-full bg-emerald-300/24 blur-3xl" />
        <div className="absolute left-1/3 top-[-120px] h-[240px] w-[240px] rounded-full bg-teal-300/14 blur-3xl" />
      </div>

      <div className="relative flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <span className="grid h-13 w-13 place-items-center rounded-[24px] border border-emerald-100 bg-white text-emerald-700 shadow-[0_14px_32px_rgba(16,185,129,.13)] backdrop-blur-xl transition-all duration-300 hover:-rotate-6 hover:scale-110">
            <Icon size={22} />
          </span>

          <div>
            <div className="text-xs font-black uppercase tracking-[0.18em] text-emerald-600">
              Gestión activa
            </div>

            <h2 className="mt-1 text-2xl font-black tracking-tight text-slate-950">
              {section.title}
            </h2>

            <p className="mt-1 max-w-2xl text-sm font-semibold leading-6 text-slate-500">
              {section.subtitle}
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onReload}
          disabled={loading}
          className="inline-flex items-center justify-center gap-2 rounded-2xl border border-emerald-200 bg-white px-5 py-3 text-sm font-black text-slate-700 shadow-[0_12px_28px_rgba(15,23,42,.07)] backdrop-blur-xl transition-all duration-300 hover:-translate-y-1 hover:bg-emerald-50 hover:text-emerald-700 hover:shadow-[0_18px_40px_rgba(16,185,129,.13)] disabled:cursor-not-allowed disabled:opacity-55"
        >
          <RefreshCw size={16} className={loading ? "animate-spin" : ""} />
          Actualizar
        </button>
      </div>
    </div>
  );
}